import React from 'react';

import { useTranslation } from '@mint-lib/i18n';
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerRoot,
  DrawerTitle,
} from '@mint-lib/tw-components';

import { useScheduleDrawer } from '../../../hooks/useScheduleDrawer.js';
import { useToggleScheduleDialog } from '../../../hooks/useToggleScheduleDialog.jsx';
import { CreateScheduleDialog } from '../CreateScheduleDialog/index.js';
import { DeleteQueriesDialog } from './DeleteQueriesDialog.jsx';
import { DrawerContent as ScheduleDrawerContent } from './DrawerContent.jsx';

const ScheduleDrawer = () => {
  const { t } = useTranslation('@mint-lib/ai-chat');
  const { isOpen, toggle } = useScheduleDrawer();

  const { isOpenScheduleDialog, setIsOpenScheduleDialog } =
    useToggleScheduleDialog();

  return (
    <Drawer open={isOpen} onOpenChange={toggle}>
      <DrawerPortal>
        <DrawerOverlay className="duration-500" />
        <DrawerRoot
          data-testid="schedule-drawer"
          aria-describedby={undefined}
          onOpenAutoFocus={(e) => e.preventDefault()}
          className="duration-500"
        >
          <DrawerHeader>
            <DrawerTitle>{t('Scheduled queries')}</DrawerTitle>
          </DrawerHeader>
          <DrawerContent className="flex justify-center gap-4">
            <div className="flex h-full w-[75vw] flex-col">
              <ScheduleDrawerContent />
            </div>
          </DrawerContent>
        </DrawerRoot>
      </DrawerPortal>
      <DeleteQueriesDialog />

      <CreateScheduleDialog
        key={String(isOpenScheduleDialog)}
        isOpen={isOpenScheduleDialog}
        onClose={() => {
          setIsOpenScheduleDialog(false);
        }}
      />
    </Drawer>
  );
};

export { ScheduleDrawer };
